module.exports = __webpack_public_path__ + "static/other/gameFindHelpers.4c5bc02f.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameFindHelpers.json
// module id = 2596
// module chunks = 0